import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputFieldMatchingDirective } from './input-field-matching.directive';


@NgModule({
  declarations: [
    InputFieldMatchingDirective
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    InputFieldMatchingDirective
  ]
})
export class InputFieldMatchingModule {
}
